export default "__VITE_ASSET__BV_cOP5E__"